export class PersonalityTestTracker {

	static fireTracking(action: string, label?: string, property?: string, value?: number): void {
		if (!window.snowplow) {
			console.warn('PersonalityTestTracker.fireTracking: snowplow not available on window.');
			return;
		}

		window.snowplow('trackStructEvent', {
			category: 'personality_test',
			action: action,
			label: label,
			property: property,
			value: value
		});
	}
}
